import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box } from '..';
import { RenderInView } from './RenderInView';
import { SlideWrapper } from './SlideBox.styled';
const Slide = ({ onSlideChange, slideSpacing, stretchHeight, index, content, isCurrentSlide, width, numSlides, slideBoxRef, }) => {
    const ref = useRef();
    useEffect(() => {
        var _a, _b;
        /* istanbul ignore next */
        if (isCurrentSlide === true && typeof ((_a = slideBoxRef === null || slideBoxRef === void 0 ? void 0 : slideBoxRef.current) === null || _a === void 0 ? void 0 : _a.scroll) === 'function' && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            const { offsetLeft, offsetParent, offsetWidth } = ref.current;
            const { offsetWidth: parentOffset } = offsetParent || {};
            (_b = slideBoxRef === null || slideBoxRef === void 0 ? void 0 : slideBoxRef.current) === null || _b === void 0 ? void 0 : _b.scroll({ left: offsetLeft - parentOffset + offsetWidth });
        }
    }, [isCurrentSlide, ref]);
    return (React.createElement(SlideWrapper, { "data-testid": `slide${index + 1}`, ref: ref, width: width },
        React.createElement(RenderInView, { onSlideChange: onSlideChange, index: index, slideRef: ref },
            React.createElement(Box, { height: '100%', pl: index === 0 ? 2 : 0, pr: index === numSlides - 1 ? 2 : 0, ml: index === 0 ? 0 : slideSpacing, mr: index === numSlides - 1 ? 0 : slideSpacing }, stretchHeight ? React.cloneElement(content, { style: { 'min-height': '100%' } }) : content))));
};
Slide.propTypes = {
    onSlideChange: PropTypes.func,
    slideSpacing: PropTypes.number,
    stretchHeight: PropTypes.bool,
    index: PropTypes.number,
    content: PropTypes.node,
    isCurrentSlide: PropTypes.bool,
    width: PropTypes.any,
    numSlides: PropTypes.number,
    slideBoxRef: PropTypes.any,
};
export { Slide };
//# sourceMappingURL=Slide.js.map